__turbopack_context__.v({
  "accordion": "commonTableMobile-module-scss-module__vjLGBG__accordion",
  "accordionBody": "commonTableMobile-module-scss-module__vjLGBG__accordionBody",
  "accordionHeader": "commonTableMobile-module-scss-module__vjLGBG__accordionHeader",
  "commonTableMobile": "commonTableMobile-module-scss-module__vjLGBG__commonTableMobile",
  "ctaContainer": "commonTableMobile-module-scss-module__vjLGBG__ctaContainer",
  "ctaWrapper": "commonTableMobile-module-scss-module__vjLGBG__ctaWrapper",
  "description": "commonTableMobile-module-scss-module__vjLGBG__description",
  "title": "commonTableMobile-module-scss-module__vjLGBG__title",
});
